/* eslint-disable camelcase */
import { css } from '@emotion/core';

export const $definitionForm = css`
  margin: 20px 0;
`;
